// extracted by mini-css-extract-plugin
module.exports = {"rectangle":"MarkShape__rectangle___XbjHs"};